export default "__VITE_ASSET__BE4bKPEZ__"